<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">油证通场景介绍</p>
        <p>促力营销费用消耗， 创新，高效营销模式</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p
          v-for="(nl, index) in navList"
          :key="index"
          :class="anchorId == index ? 'nowAnchor' : ''"
          @click="changeanchorId(index, nl.id)"
        >
          {{ nl.text }}
        </p>
      </div>
    </div>
    <!-- 中心功能 -->
    <section class="first-introduce flexDiv mainDivWidth" id="centralFunction">
      <div class="introduceTextImg">
        <img
          src="static/img/sceneImg/scene5-oilCard/firstImg.png"
          class="introduceImg"
        />
      </div>
      <div class="first-introduceText">
        <div class="introduceText-Title flexDiv">
          <p class="titleBg">中心功能</p>
          <p class="subheading">CENTRAL FUNCTION</p>
        </div>
        <div class="cer-FunCon">
          <p>
            油证通产品是面向C端用户的营销升级体系，采用零静默的方式，将有限的营销费用，通过用户贡献度和留存度来进行分配；
            助力合作方提升营销效果，同时达到提高用户活跃度和用户粘性的目的。
          </p>
        </div>
      </div>
    </section>
    <!-- 产品优势 -->
    <section class="productAdv" id="productAdv">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">产品优势</h3>
        <div class="productAdv-Con flexDiv">
          <div
            class="productAdv-explain flexDiv"
            v-for="(pal, index) in productAdvList"
            :key="index"
          >
            <img :src="pal.img" />
            <p class="">{{ pal.text }}</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 首页展示 -->
    <section id="showHome" class="mainDivWidth">
      <h3 class="sectionTitle">首页展示</h3>
      <div class="showHome">
        <img
          src="static/img/sceneImg/scene5-oilCard/showPhone.png"
          class="visible-xs showHomePhone"
        />
        <div class="showHome-flow show-right01 flexDiv">
          <img src="static/img/sceneImg/scene5-oilCard/show01.png" />
          <div>
            <p class="title">兑换</p>
            <p>权证兑换油滴，油滴换购优惠券</p>
            <p class="title">规则</p>
            <p>玩法、规则说明</p>
            <p class="title">领油滴</p>
            <p>每日签到领取油滴</p>
          </div>
        </div>
        <div class="showHome-flow show-right02 flexDiv">
          <img src="static/img/sceneImg/scene5-oilCard/show02.png" />
          <div>
            <p class="title">兑换奖池</p>
            <p>当前油滴奖池价值； 当前权证兑换油滴的价格（=总油滴/总权证）</p>
          </div>
        </div>
        <div class="showHome-flow show-right03 flexDiv">
          <img src="static/img/sceneImg/scene5-oilCard/show03.png" />
          <div>
            <p class="title">我要挣权证</p>
            <p>业务场景入口</p>
          </div>
        </div>
        <div class="showHome-flow show-left01 flexDiv">
          <div>
            <p class="title">分红树</p>
            <p>
              根据持有权证多少，分红树大小不同；红苹果为每日分红，可直接领取至个人账户；绿苹果为预计分红
            </p>
          </div>
          <img src="static/img/sceneImg/scene5-oilCard/show04.png" />
        </div>
        <div class="showHome-flow show-left02 flexDiv">
          <div>
            <p class="title">宝箱抽奖</p>
            <p>可通过抽强获得神秘油滴大奖</p>
          </div>
          <img src="static/img/sceneImg/scene5-oilCard/show05.png" />
        </div>
      </div>
    </section>
    <!-- 使用流程 -->
    <section class="useFlow" id="useFlow">
      <div class="mainDivWidth">
        <h3 class="sectionTitle textCenter">使用流程</h3>
        <img src="static/img/sceneImg/scene5-oilCard/flowImg.jpg" />
      </div>
    </section>
    <!-- 使用效果 -->
    <section class="mainDivWidth" id="useEffect">
      <h3 class="sectionTitle textCenter">使用效果</h3>
      <div class="trisectionImgTextDiv flexDiv smallRadius">
        <div class="flexDiv" v-for="(uel, index) in useEffectList" :key="index">
          <div class="imgDiv">
            <img :src="uel.img" />
          </div>
          <div class="textDiv">
            <p class="cooper-title textCenter" v-text="uel.title"></p>
            <p v-text="uel.text"></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "sceneOilCard",
  data: function() {
    return {
      anchorId: 0,
      navList: [
        { text: "中心功能", id: "centralFunction" },
        { text: "产品优势", id: "productAdv" },
        { text: "首页展示", id: "showHome" },
        { text: "使用流程", id: "useFlow" },
        { text: "使用效果", id: "useEffect" }
      ],
      productAdvList: [
        {
          img: "static/img/sceneImg/scene5-oilCard/productAdv01.png",
          text: "系统易对接"
        },
        {
          img: "static/img/sceneImg/scene5-oilCard/productAdv02.png",
          text: "娱乐性强"
        },
        {
          img: "static/img/sceneImg/scene5-oilCard/productAdv03.png",
          text: "刺激用户活跃度"
        },
        {
          img: "static/img/sceneImg/scene5-oilCard/productAdv04.png",
          text: "参数灵活配置"
        }
      ],
      useEffectList: [
        {
          img: "static/img/sceneImg/scene5-oilCard/effectIcon01.png",
          title: "可应用场景推荐",
          text: "油证通内测白名单活动可快速嫁接到现有业务场景。"
        },
        {
          img: "static/img/sceneImg/scene5-oilCard/effectIcon02.png",
          title: "业务资源整合",
          text:
            "为合作方提供定制化营销方案，同时对接多个业务场景，实现用户资源共享。"
        },
        {
          img: "static/img/sceneImg/scene5-oilCard/effectIcon03.png",
          title: "C端用户活跃及保有",
          text:
            "该产品可以增加用户粘性及活跃度，有效的实现了对触达用户的二次营销。"
        }
      ],
      idconts:"",
    };
  },
  created(){
    this.idconts = this.getQueryString('idcont');
  },
  mounted() {
    if(this.idconts){
      $(".mainCon").css('margin-top','0')
      $("#nava").css('display','none')
      $(".scene-Header").css('display','none')
      $(".servebanner").css('display','none')
      $(".footer").css('display','none')
    }
  },
  methods: {
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id) {
      this.anchorId = num;
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      return false; // 返回false可以避免在原链接后加上#
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return r[2]; return null;
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/sceneCss/sceneStyle";
@import "../../assets/css/sceneCss/sceneFive";
</style>



// WEBPACK FOOTER //
// src/pages/scenePage/scene5-oilCard.vue